import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import CreateSubAdminList from "views/pages/createsubadmin/CreateSubAdminList";
import AddCreateSubAdmin from "views/pages/createsubadmin/AddCreateSubAdmin";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import Loader from "@core/helper/Loader";

const CreateSubAdmin = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [createsubadminList, setCreateSubadminList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState("");

  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteSubAdmin)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = createsubadminList.filter((o) => o.id !== id);
            setCreateSubadminList(filter);
            fetchCreateSubadminList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setSearchText("");
    setType(type);
    if (id) {
      const findList = createsubadminList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };

  useEffect(() => {
    fetchCreateSubadminList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageSize, pageNumber]);

  const fetchCreateSubadminList = () => {
    Loader.isLoading(true);

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "DESC",
      searchText: searchText,
    };
    APICall("post", payload, EndPoints.getSubAdmin)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setCreateSubadminList(results);
          setTotalRecord(totalCount);
        } else {
          setCreateSubadminList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const SubmitCreateSubAdminList = () => {
    fetchCreateSubadminList();
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
          Sub Admin
          </Typography>
        }
      />
      <Grid item xs={12}>
        <CreateSubAdminList
          handleDeleteModal={handleDeleteModal}
          deleteOpen={deleteOpen}
          handleOpen={handleOpen}
          createsubadminList={createsubadminList}
          pageSize={pageSize}
          setPageSize={setPageSize}
          searchText={searchText}
          setSearchText={setSearchText}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          totalRecord={totalRecord}
        />
      </Grid>
      {openModal && (
        <AddCreateSubAdmin
          open={openModal}
          toggle={handleOpen}
          type={type}
          heading={
            type === "edit" ? "Update Sub Admin" : "Create Sub Admin"
          }
          onSubmitCreateSubAdminList={SubmitCreateSubAdminList}
          updateData={updateData}
        />
      )}
    </Grid>
  );
};

export default CreateSubAdmin;
